import {TASK} from "../../../services";
import {FileController} from "../../Boilerplate/FileController";

const docKey = ['match', 'params', 'id'];
const subDocKey = ['match', 'params', 'taskId'];
const indexType = 'task';
const topLevelName = 'Task';

export const TaskFiles = FileController(TASK, indexType, docKey, subDocKey, topLevelName);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/TaskFiles.js